// export const BASE_URL = 'https://8t45chcptb.execute-api.ap-south-1.amazonaws.com/development/v1';

// export const BOUNTY_MANAGER_PROGRAM_ID = 'HNgRCwJ2qaMSzDsor9b8T76PhF2tkRJ5eiYM3kj98xrS';

// export const API_KEY = 'ab390b6a-1be0-4d57-8195-4ef77538db87';

// export const API_URL = 'https://pro-api.coinmarketcap.com/v2/cryptocurrency/quotes/latest';
// export const RPC_ENDPOINT = 'https://mainnet.helius-rpc.com/?api-key=216323ba-6f1f-4e42-a032-ddff354c0550';

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const BOUNTY_MANAGER_PROGRAM_ID = process.env.REACT_APP_BOUNTY_MANAGER_PROGRAM_ID;
export const API_KEY = process.env.REACT_APP_API_KEY;
export const API_URL = process.env.REACT_APP_API_URL;
export const RPC_ENDPOINT = process.env.REACT_APP_RPC_ENDPOINT;
export const RPC_ENDPOINT_L = process.env.REACT_APP_RPC_ENDPOINT_L;
export const merkletree = process.env.REACT_APP_MERKLETREE;
export const mintpriceinsol = process.env.REACT_APP_MINTPRICEINSOL;
export const merkletreeprivatekey = process.env.REACT_APP_MERKLE_TREECREATOR_PRIVATEKEY;
export const evmRPCURL = process.env.REACT_APP_EVM_RPC_URL;
export const MINTPRICE_USD = process.env.REACT_APP_MINTPRICE_USD;
export const COINGECKO_URL = process.env.REACT_APP_COINGECKO_URL;
export const IC_CONTRACTADDRESS = process.env.REACT_APP_IC_CONTRACTADDRESS;
export const IC_FEE_RECIEVERADDRESS=process.env.REACT_APP_IC_FEE_RECIEVERADDRESS
export const BATCH_MAX=process.env.REACT_APP_BATCH_MAX
export const MULTISEND_CONTRACTADDRESS=process.env.REACT_APP_MULTISEND_CONTRACTADDRESS
